import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const StyledTransparent = css `
  background: ${({ theme }) => theme.Color.NeutralsFixed.Light};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};

  &::after {
    content: '';
    position: absolute;
    inset-inline-end: 1px;
    top: 0;
    display: block;
    border-radius: 0;
    width: calc(100% + 10px);
    height: 2px;
    transform-origin: right;
    transform: rotate(-45deg);
    background-color: #f5222d;
  }
`;
export const StyledPicker = css `
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: conic-gradient(
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  );

  &::after {
    z-index: 2;
    content: '';
    position: absolute;
    display: inline-block;
    background-color: white;
    width: 70%;
    height: 70%;
  }

  svg {
    z-index: 3;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    top: 0px;
    margin: auto;
    text-align: center;
  }
`;
export const StyledSelected = css `
  box-shadow: inset 0 0 0
    ${({ theme }) => `${rem(theme.Border.Size.Medium)} ${theme.Color.Neutrals.Paper}`};
  border: ${rem(1.5)} solid ${({ theme }) => theme.Color.Brand.Primary};
`;
export const StyledHover = css `
  box-shadow: inset 0 0 0
    ${({ theme }) => `${rem(theme.Border.Size.Medium)} ${theme.Color.Neutrals.Paper}`};
  border: ${rem(1.5)} solid ${({ theme }) => theme.Color.Neutrals.Border};
`;
export const variantCircle = css `
  border-radius: 50%;

  &::after {
    border-radius: 50%;
  }
`;
export const variantRect = css `
  border-radius: 0;
  border: none;

  &::after {
    border-radius: 0;
  }
`;
export const variantRounded = css `
  ${({ theme }) => `
    border-radius: ${rem(theme.Border.Radius.Small)};

    &::after {
      border-radius: ${rem(theme.Border.Radius.Small)};
    }
  `}
`;
export const StyledColorButton = styled.div `
  display: block;
  position: relative;
  padding: 0;
  box-sizing: border-box;
  background: ${({ color }) => color || '#000000'};
  border-style: solid;
  border-width: ${({ theme, isPicker }) => isPicker ? 0 : rem(theme.Border.Size.Small)};
  border-color: ${({ color, theme, isPicker }) => {
    if (color === null || color === void 0 ? void 0 : color.startsWith('#')) {
        return darken(0.1, color.substring(0, 7) || '#000000');
    }
    else if (color === 'transparent') {
        return theme.Color.Neutrals.Border;
    }
    return color;
}};
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: ${({ theme }) => `border-color ${theme.Transition.Timing.Out}, box-shadow ${theme.Transition.Timing.Out};`};

  &:hover {
    ${({ variant, isPicker, color }) => variant !== 'rect' && !isPicker && color !== 'transparent' && StyledHover}

    transition: ${({ theme }) => `border-color ${theme.Transition.Timing.In}, box-shadow ${theme.Transition.Timing.In};`};
  }

  ${({ isPicker, color }) => !isPicker && color === 'transparent' && StyledTransparent}

  ${({ variant }) => {
    switch (variant) {
        case 'circle':
            return variantCircle;
        case 'rect':
            return variantRect;
        case 'rounded':
            return variantRounded;
        default:
            return '';
    }
}}

  ${({ isPicker }) => isPicker && StyledPicker}

  ${({ isSelected }) => isSelected && StyledSelected}

  ${({ size, theme }) => css `
    width: ${rem(theme.Icon.Size[size])};
    height: ${rem(theme.Icon.Size[size])};
  `}
`;
export const StyledInputColor = styled.input `
  opacity: 0;
  appearance: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};

  ${({ isReadOnly }) => isReadOnly &&
    css `
      pointer-events: none;
    `}
`;
//# sourceMappingURL=ColorBullet.style.js.map